module.exports = __webpack_public_path__ + "img/daphne-and-the-dragon.971a30a2.jpg";